import React from "react";

export function Panel({ title, subtitle, actions, accent, children, className = "", testid }) {
    const accentClass = accent ? `kcc-${accent}-accent` : "";
    return (
        <section className={`kcc-panel ${accentClass} p-5 ${className}`} data-testid={testid}>
            {(title || actions) && (
                <header className="flex items-start justify-between gap-4 mb-4">
                    <div>
                        {title && <h3 className="font-display text-lg font-semibold text-white tracking-tight">{title}</h3>}
                        {subtitle && <p className="kcc-text-silver text-xs mt-1">{subtitle}</p>}
                    </div>
                    {actions && <div className="flex items-center gap-2">{actions}</div>}
                </header>
            )}
            {children}
        </section>
    );
}

export function ModuleHeader({ title, kicker, description, image, actions, testid }) {
    return (
        <div className="kcc-panel overflow-hidden relative" data-testid={testid || "module-header"}>
            {image && (
                <div className="absolute inset-0 opacity-30 pointer-events-none">
                    <img src={image} alt="" className="w-full h-full object-cover" />
                    <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(13,16,23,0.98), rgba(13,16,23,0.6) 60%, rgba(13,16,23,0.9))" }} />
                </div>
            )}
            <div className="relative p-6 md:p-8">
                {kicker && <div className="kcc-label text-kcc-copper-light">{kicker}</div>}
                <h1 className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-white mt-2">{title}</h1>
                {description && <p className="kcc-text-silver mt-2 max-w-3xl text-sm md:text-base leading-relaxed">{description}</p>}
                {actions && <div className="mt-5 flex flex-wrap gap-2">{actions}</div>}
            </div>
        </div>
    );
}
